export const mutation_add_indicatore_anomalia = `
mutation addIndicatoreAnomalia($fascicoloId: Int!, $date: timestamp!, $providedBy: String!, $result: String!, $note: String) {
    insert_indicatore_anomalia_one(object: {FascicoloId: $fascicoloId, Date: $date, ProvidedBy: $providedBy, Result: $result, Note: $note }) {
        Id
        Date
        ProvidedBy
        Result
        Note
        CreatedOn
        ModifiedOn
        CreatedBy
        ModifiedBy
    }
}`;
export const mutation_update_indicatore_anomalia = `
mutation updateIndicatoreAnomalia($id: Int!, $fascicoloId: Int!, $date: timestamp!, $providedBy: String!, $result: String!, $note: String) {
    update_indicatore_anomalia(where: {Id: {_eq: $id}, FascicoloId: {_eq: $fascicoloId}}, _set: {Date: $date, ProvidedBy: $providedBy, Result: $result, Note: $note, ModifiedOn: "now()"}) {
        returning {
            Id
            Date
            ProvidedBy
            Result
            Note
            CreatedOn
            ModifiedOn
            CreatedBy
            ModifiedBy
        }
    }
}`;
export const mutation_delete_indicatore_anomalia = `
mutation deleteIndicatoreAnomalia($id: Int!, $fascicoloId: Int!) {
    delete_indicatore_anomalia(where: {Id: {_eq: $id}, FascicoloId: {_eq: $fascicoloId}}) {
        affected_rows
    }
}`;